<template lang="pug">
    .slider-simple
    
        .slider-simple__container(
            v-observe-visibility='{callback: blockVisibilityChanged, throttle: 300}'
            )

            .slider-simple-nav-prev
                .slider-simple-nav-button(ref='swiperPrev')
                    svg(xmlns='http://www.w3.org/2000/svg', viewBox='0 0 512 512')
                        path(d='M388.425 241.951L151.609 5.79c-7.759-7.733-20.321-7.72-28.067.04-7.74 7.759-7.72 20.328.04 28.067l222.72 222.105-222.728 222.104c-7.759 7.74-7.779 20.301-.04 28.061a19.8 19.8 0 0014.057 5.835 19.79 19.79 0 0014.017-5.795l236.817-236.155c3.737-3.718 5.834-8.778 5.834-14.05s-2.103-10.326-5.834-14.051z')


            .swiper-container(ref='swiper')

                .swiper-wrapper

                    .swiper-slide(
                        v-for='slide in slides',
                        :key='slide.heading[0]'
                        )

                        .slide-simple
                            Heading.slide-simple__heading(
                                tag='h3'
                                :text='slide.heading'
                                color='red',
                                :centered='true'
                                )
                            
                            .slide-simple__text(v-html='slide.text')

            .slider-simple-nav-next
                .slider-simple-nav-button(ref='swiperNext')
                    svg(xmlns='http://www.w3.org/2000/svg', viewBox='0 0 512 512')
                        path(d='M388.425 241.951L151.609 5.79c-7.759-7.733-20.321-7.72-28.067.04-7.74 7.759-7.72 20.328.04 28.067l222.72 222.105-222.728 222.104c-7.759 7.74-7.779 20.301-.04 28.061a19.8 19.8 0 0014.057 5.835 19.79 19.79 0 0014.017-5.795l236.817-236.155c3.737-3.718 5.834-8.778 5.834-14.05s-2.103-10.326-5.834-14.051z')
        
        .slider-simple__pagination
            .slider-simple__pagination-wrapper
                .slider-simple__bullet(
                    v-for='(bullet, bulletIndex) in slides',
                    :class='{active: activeSlide === bulletIndex}'
                    )
                        .slider-simple__bullet-round(@click='changeSlide(bulletIndex)')


</template>
<script>
import Heading from '@/components/utility/Heading.vue';
import {Swiper, Navigation, EffectFade, Autoplay} from 'swiper/js/swiper.esm.js';

Swiper.use([Navigation, EffectFade, Autoplay]);

export default {
    name: 'Slider',

    data() {
        return {
            swiper: null,
            activeSlide: 0,
            swiperHeight: 0
        };
    },

    props: {
        slides: Array
    },

    components: {
        Heading
    },

    methods: {
        blockVisibilityChanged(isVisible) {
            if (isVisible && !this.swiper) {
                this.initSwiper();
            } else if (!isVisible && this.swiper) {
                this.destroySwiper();
            }
        },

        initSwiper() {
            this.$refs.swiper.style.height = 'auto';
            this.swiper = new Swiper(this.$refs.swiper, {
                speed: 1200,
                autoHeight: true,
                simulateTouch: false,
                effect: 'fade',
                autoplay: {
                    delay: 3000
                },
                fadeEffect: {
                    crossFade: true
                },
                navigation: {
                    nextEl: this.$refs.swiperNext,
                    prevEl: this.$refs.swiperPrev
                }
            });

            this.swiper.on('slideChange', () => (this.activeSlide = this.swiper.activeIndex));
            this.swiper.on('beforeDestroy', () => (this.swiperHeight = this.$refs.swiper.getBoundingClientRect().height));
        },

        changeSlide(index) {
            this.swiper.slideTo(index);
            this.activeSlide = index;
        },

        destroySwiper() {
            this.getSwiperHeight();
            this.swiper.destroy();
            this.swiper = null;
            this.$refs.swiper.style.height = `${this.swiperHeight}px`;
        },

        getSwiperHeight() {
            this.swiperHeight = this.$refs.swiper.getBoundingClientRect().height;
        }
    }
};
</script>

<style lang="scss">
@import '@/assets/css/vars.scss';

.slider-simple {
    display: flex;
    flex-direction: column;

    &__container {
        display: flex;
        flex-direction: row;
    }

    &__pagination {
        display: flex;
        margin: 3vw 0;

        &-wrapper {
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            margin: auto;
        }
    }

    &__bullet {
        position: relative;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        margin: auto;

        &-round {
            display: flex;
            width: 2vw;
            height: 2vw;
            border-radius: 50%;
            border: 2px solid var(--color-main-blue-light);
            cursor: pointer;

            @media (--viewport-mobile) {
                width: 8vw;
                height: 8vw;
            }

            &:before {
                content: '';
                display: inline-block;
                position: relative;
                margin: auto;
                width: 0.5vw;
                height: 0.5vw;
                border-radius: 50%;
                background: var(--color-main-red);
                opacity: 0;
                transition: opacity 0.6s ease;

                @media (--viewport-mobile) {
                    width: 2vw;
                    height: 2vw;
                }
            }

            &:hover {
                &:before {
                    opacity: 1;
                }
            }
        }

        &.active {
            .slider-simple__bullet-round {
                &:before {
                    opacity: 1;
                }
            }
        }

        &:before {
            content: '';
            display: inline-block;
            width: 8vw;
            height: 2px;
            background-color: var(--color-main-blue-light);

            @media (--viewport-mobile) {
                width: 14vw;
            }
        }

        &:first-child {
            &:before {
                display: none;
            }
        }
    }

    &-nav {
        &-button {
            cursor: pointer;
            width: 50px;
            margin: auto;

            svg {
                transition: fill 0.6s ease;
                fill: var(--color-main-blue);
            }

            &:hover {
                svg {
                    fill: var(--color-main-red);
                }
            }

            &.swiper-button-disabled {
                svg {
                    fill: rgba(0, 0, 0, 0.3);
                }
            }
        }

        &-prev,
        &-next {
            display: flex;
            width: 25%;

            @media (--viewport-mobile) {
                width: 5vw;
            }
        }

        &-prev {
            svg {
                transform: rotate(180deg);
            }
        }
    }

    .swiper {
        &-container {
            width: 50%;

            @media (--viewport-mobile) {
                width: 90%;
            }
        }
    }

    .slide-simple {
        &__text {
            text-align: center;
        }
    }
}
</style>
